import logo from './white_logo.png';
import Loading from '../../Common/components/Loading';
import useSlideshowBehaviors from './hooks/useSlideshowBehaviors';
import { MediaWrapper } from './GalleryPreviewImage';

interface SlideshowViewerProps {
    isLoading: boolean;
    gridWidth: number;
    gridHeight: number;
    gallery: GalleryObject;
    gridGap: number;
    rotationSpeed: number;
    photos: any;
    displayHeader: boolean;
}

export default function SlideshowViewer({
    isLoading,
    gallery,
    photos,
    gridWidth,
    gridHeight,
    gridGap,
    rotationSpeed,
    displayHeader,
}: SlideshowViewerProps) {
    const { displayPhotos, previousPhotos } = useSlideshowBehaviors(
        gridWidth * gridHeight,
        photos,
        rotationSpeed,
    );

    console.log('Display photos', displayPhotos);
    const previousRows = [];
    for (let i = 0; i < previousPhotos.length; i += gridWidth) {
        const row = previousPhotos.slice(i, i + gridWidth);
        previousRows.push(row);
    }

    const rows = [];
    for (let i = 0; i < displayPhotos.current.length; i += gridWidth) {
        const row = displayPhotos.current.slice(i, i + gridWidth);
        rows.push(row);
    }

    return (
        <>
            <Loading isLoading={isLoading} />
            {!isLoading && (
                <>
                    {displayHeader ? (
                        <div className="Gallery-header">
                            <div className="Gallery-header-title">
                                <img
                                    src={gallery?.logo || logo}
                                    alt="Smilebooth Logo"
                                />
                            </div>
                            <div className="Gallery-name">{gallery.name}</div>
                        </div>
                    ) : null}

                    <div
                        className={`Gallery-content relative`}
                        style={{ top: displayHeader ? '62px' : '0' }}
                        id="galleryContainer"
                    >
                        <div
                            className={`Slideshow-grid-container flex h-full  absolute z-10 max-w-full overflow-hidden`}
                        >
                            {rows.map((row, rowIndex) => (
                                <div key={rowIndex} className={`flex-1`}>
                                    {row.map((photo, photoIndex) => (
                                        <div
                                            style={{
                                                padding: `${gridGap}px`,
                                            }}
                                            key={photo.originalUri}
                                        >
                                            <MediaWrapper
                                                key={photoIndex}
                                                media={photo}
                                                isExpanded={true}
                                            />
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        <div
                            className={`Slideshow-grid-container flex  absolute z-10 max-w-full overflow-hidden`}
                        >
                            {previousRows.map((row, rowIndex) => (
                                <div key={rowIndex} className={`flex-1`}>
                                    {row.map((photo, photoIndex) => (
                                        <div
                                            style={{
                                                padding: `${gridGap}px`,
                                            }}
                                            className="starting-visible fade-out-5"
                                            key={photo.originalUri}
                                        >
                                            <MediaWrapper
                                                key={photoIndex}
                                                media={photo}
                                                isExpanded={true}
                                            />
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </>
    );
}
